import { UseFormReturn } from 'react-hook-form';

import { WorkDay } from '@/modules/common/api';
import { OrganizationFormValues } from '@/modules/onboarding/organization-setup';
import { DayOfWeek, ordinalToDayOfWeek } from '@/types/day-of-week';

import {
  applyDefaultWorkSchedule,
  formatMinuteOfTheDayToTime,
} from './apply-default-work-schedule';

/**
 * Applies the organization's work schedule (or default) to the form.
 * Handles all try/catch and fallback logic.
 */
export function applyOrganizationWorkSchedule(
  form: UseFormReturn<OrganizationFormValues>,
  organizationData: any // Should be typed more strictly in real code
) {
  if (
    organizationData.workSchedule &&
    organizationData.workSchedule.days &&
    organizationData.workSchedule.days.length > 0
  ) {
    try {
      const workDaysMap = new Map<DayOfWeek, WorkDay>();
      organizationData.workSchedule.days.forEach((day: WorkDay) => {
        if (day.dayOfWeek < 0 || day.dayOfWeek > 6) {
          console.warn(`Invalid day of week: ${day.dayOfWeek}. Expected 0-6.`);
          return;
        }
        workDaysMap.set(ordinalToDayOfWeek(day.dayOfWeek), day);
      });
      Object.values(DayOfWeek).forEach((dayOfWeek: DayOfWeek) => {
        const workDay = workDaysMap.get(dayOfWeek);
        if (workDay) {
          form.setValue(`workSchedule.${dayOfWeek}.enabled`, true);
          form.setValue(
            `workSchedule.${dayOfWeek}.startTime`,
            formatMinuteOfTheDayToTime(workDay.startTimeMinutes)
          );
          form.setValue(
            `workSchedule.${dayOfWeek}.endTime`,
            formatMinuteOfTheDayToTime(workDay.endTimeMinutes)
          );
        } else {
          form.setValue(`workSchedule.${dayOfWeek}.enabled`, false);
          form.setValue(`workSchedule.${dayOfWeek}.startTime`, null);
          form.setValue(`workSchedule.${dayOfWeek}.endTime`, null);
        }
      });
    } catch (error) {
      console.error('Error initializing work schedule:', error);
      applyDefaultWorkSchedule(form);
    }
  } else {
    applyDefaultWorkSchedule(form);
  }
}
